import * as Models from 'contracts/models';

export const Endpoint = ({ project_id, _id }: Pick<Payload, 'project_id' | '_id'>) =>
    `/vscanner/api/v2/projects/${project_id}/tasks/${_id}`;

export type Payload = Pick<
    Models.Vscanner.ProjectTask,
    '_id' | 'project_id' | 'enabled' | 'name' | 'networks' | 'schedule' | 'ports' | 'timing'
>;

export type Response = Models.Vscanner.ProjectTask;
